import * as React from 'react';
export const openLockSvg = React.forwardRef(function openLockSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.75 11.25a1.25 1.25 0 1 0-1.5 0v1a.75.75 0 0 0 1.5 0v-1Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5 4v2h8.5a1 1 0 0 1 1 1v6a3 3 0 0 1-3 3h-7a3 3 0 0 1-3-3V7a1 1 0 0 1 1-1h1V4a4 4 0 0 1 4-4h1a4 4 0 0 1 4 4A.75.75 0 0 1 11 4a2.5 2.5 0 0 0-2.5-2.5h-1A2.5 2.5 0 0 0 5 4ZM3 7.5V13a1.5 1.5 0 0 0 1.5 1.5h7A1.5 1.5 0 0 0 13 13V7.5H3Z',
    }),
  );
});
openLockSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var openLock = {
  category: 'icon',
  colorable: true,
  name: 'openLock',
  svg: openLockSvg,
};
